module.exports = __webpack_public_path__ + "static/Mindtouch-a8534a264418708f4cf6b1cbf548b3c7.png";